"use client";

import {
// biome-ignore lint/style/noRestrictedImports: this is fine
useIsAuthenticated, useIsReady as useWalletReady } from "@opensea/wallet";
import { useServerWallet } from "@/components/connect/ServerWalletProvider";
export function useAuthenticated() {
  const {
    authenticated: serverAuthenticated
  } = useServerWallet();
  const walletAuthenticated = useIsAuthenticated();
  const walletReady = useWalletReady();
  return walletReady ? walletAuthenticated : serverAuthenticated;
}